

















































































































import Vue from 'vue';
import { mapState } from 'vuex';
import Helpers from '../../mixins/helpers';
import HeadingColumns from '@/components/dumb/HeadingColumns.vue';
import Analytics from '@/mixins/analytics';
import VueRecaptcha from 'vue-recaptcha';

export default Vue.extend({
	name: 'TradeInSelected', 
	components: {
		HeadingColumns, 
		VueRecaptcha
	},
	props: {
		low: {
			type: Number
		}, 
		high: {
			type: Number
		}, 
		name: {
			type: String
		}, 
		image: {
			type: String
		}, 
		comment: {
			type: String
		},
		selected: {
			type: Boolean
		}, 
		disabled: {
			type: Boolean
		}, 
		loading: {
			type: Boolean
		}
	},
	data(){
		return {
			recaptchaError: false,
			captchaRendered: false,
			form: {
				recaptcha: ''
			}
		};
	},
	computed: {
		recaptchaErrorMessage(): string {
			if (this.recaptchaError){
				return this.captchaRendered ? 'Captcha is a required field' : 'Your browser has blocked Captcha. Please try a different browser.';
			}
			return '';
		},
		captchaSiteKey(): string {
			return this.$store.getters.captchaSiteKey;
		},
		chosenVehicleHeadingItems(): Array<any> {
			return [
				{subHeading: 'Average Condition', heading: Helpers.getFormattedPrice(this.low)},
				{subHeading: 'Mint Condition', heading: Helpers.getFormattedPrice(this.high)}
			];
		}, 
	},
	methods: {
		setCaptcha(response: string): void {
			Helpers.clog(response);
			this.form.recaptcha = response;
            this.recaptchaError = false;
		},
		removeCaptcha(): void {
			this.form.recaptcha = '';
			this.recaptchaError = true;
		},
		handleCaptchaRendered(): void {
			this.captchaRendered = true;
		},
		handleUnselectClick(): void {
			this.$emit('unselect');
		},
		handleIncludeClick(): void {
			this.$emit('include', this.form.recaptcha);
		},
		handleEditClick(): void {
			this.$emit('edit');
		},
		handleRemoveClick(): void {
			this.$emit('remove');
		}
	}
});
